module.exports = __webpack_public_path__ + "static/media/golfer-8-b.81621bb1.png";